export default __webpack_public_path__ + "static/media/keto-bars@2x.1ca9b359.png";